
export const get_person = () => {
    return (dispatch) => {
        // console.log('in getChart')
        dispatch({
            type: "GET_PERSON"
        });
        return Promise.resolve();
    }
};
export const get_person_by_id = (id) => {
    return (dispatch) => {
        dispatch({
            type: "GET_PERSON_BY_ID",
            payload: id
        });
        return Promise.resolve();
    }
};
export const add_to_person = (product) => {
    console.log('add', product)
    return (dispatch) => {
        dispatch({
            type: "ADD_TO_PERSON",
            payload: product
        });
        return Promise.resolve();
    }
};
export const update_person_by_id = (product) => {
    // console.log('update function', product)
    // alert('Updated successfully')
    return (dispatch) => {
        dispatch({
            type: "UPDATE_PERSON_BY_ID",
            payload: product
        });
        return Promise.resolve();
    }
};
export const delete_person_by_id = (id) => {
    // console.log('dalete', id)
    // alert('Deleted from shoping cart')
    return (dispatch) => {
        dispatch({
            type: "DELETE_PERSON_BY_ID",
            payload: id
        });
        return Promise.resolve();
    }
};
export const delete_person = (id) => {
    // alert('Deleted all shoping cart')
    return (dispatch) => {
        dispatch({
            type: "DELETE_PERSON",
        });
        return Promise.resolve();
    }
};




